export enum FeedContentSourceType {
  BKK = "FEED_CONTENT_SOURCE_TYPE_BKK",
  COMPANY = "FEED_CONTENT_SOURCE_TYPE_COMPANY",
  GENERAL = "FEED_CONTENT_SOURCE_TYPE_GENERAL",
}
